/**
 * Created by renlaydel on 20/11/2017.
 */

import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import { get } from 'lodash';
import * as EntityType from '../../constants/constant_entity_types';
import * as InventoryStatus from '../../constants/constant_inventory_status';
import * as TransactionStatus from '../../constants/constant_transaction_status';
import * as LocationType from '../../constants/constant_location_types';

export function getInventoryStatus(state) {
  return state.lists.inventory_status;
}

export function getTransactionStatus(state) {
  return state.lists.transaction_status;
}

export function getEntityType(state) {
  return state.lists.entity_type;
}

export function getUserRoleAuthority(state) {
  return state.lists.user_role_authority;
}

export const getListByDocType = createSelector(
  [
    state => (state || {}).lists || {},
    (_, docType) => docType,
  ],
  (list, docType) => list[docType] || [],
);

export const getSubsidiary = (state) => {
  if (state.listData.doctype) {
    return state.listData.doctype.subsidiary || [];
  }

  return [];
};

export const getLocation = (state) => {
  if (state.listData.doctype) {
    return state.listData.doctype.location || [];
  }

  return [];
};

export const getClassification = (state) => {
  if (state.listData.doctype) {
    return state.listData.doctype.classification || [];
  }

  return [];
};

export const getFacet = (state) => {
  if (state.listData.doctype) {
    return state.listData.doctype.facet || [];
  }

  return [];
};

export const getBrand = (state) => {
  if (state.listData.doctype) {
    return state.listData.doctype.brand || [];
  }

  return [];
};

export const getItem = (state) => {
  if (state.listData.doctype) {
    return state.listData.doctype.item || [];
  }

  return [];
};

export const getEntity = (state) => {
  if (state.listData.doctype) {
    return state.listData.doctype.entity || [];
  }

  return [];
};

export const getDeliveryType = (state) => {
  if (state.listData.doctype) {
    return state.listData.doctype.delivery_type || [];
  }

  return [];
};

export const getCurrency = (state) => {
  if (state.listData.doctype) {
    return state.listData.doctype.currency || [];
  }

  return [];
};

export const getTaxGroup = (state) => {
  if (state.listData.doctype) {
    return state.listData.doctype.tax_group || [];
  }

  return [];
};

export const getReasonCode = (state) => {
  if (state.listData.doctype) {
    return state.listData.doctype.reason_code || [];
  }

  return [];
};

export const getListDataDocID = (state) => {
  if (state.listData.docid) {
    return state.listData.docid || {};
  }

  return {};
};

export const getPreferenceSettings = state => state.preference.preferences || {};

const initialFormValuesSelector = (state, form) => state.form[form].initial;

const getId = (state, id) => {
  return id;
};

export const getDoc = createSelector(
  [getId, getListDataDocID],
  (id, docId) => {
    if (!docId) return {};

    const doc = docId[id] || [];
    return doc[0] || {};
  },
);

export const getDocName = createSelector(
  [getDoc],
  (doc) => {
    return doc ? doc.name : '';
  },
);

export const getTaxGroups = createSelector(
  [getTaxGroup],
  (taxGroups) => {
    let list = [];

    if (!taxGroups) return list;

    list = taxGroups.map((taxGroup) => {
      return taxGroup;
    });

    return list;
  },
);

export const getIndexedDocTypes = createSelector(
  [getListDataDocID],
  (indexedDocTypes) => {
    let list = {};
    if (!indexedDocTypes) return list;
    return indexedDocTypes;
  },
);

export const getLocations = createSelector(
  [getLocation],
  (locations) => {
    let list = [];
    if (!locations) return list;
    return locations.map((location) => {
      return { ...location };
    });
  },
);

export const getSubsidiaries = createSelector(
  [getSubsidiary],
  (subsidiaries) => {
    let list = [];
    if (!subsidiaries) return list;
    return subsidiaries.map((subsidiary) => {
      return { ...subsidiary };
    });
  },
);

export const getTransactionStatuses = createSelector(
  [getTransactionStatus],
  (transaction_statuses) => {
    let list = [];
    if (!transaction_statuses) return list;
    return transaction_statuses.map((transaction_status) => {
      return { ...transaction_status };
    });
  },
);

export const getSuppliers = createSelector(
  [getEntity],
  (entities) => {
    let list = [];

    if (!entities) return list;

    list = entities.filter((entity) => {
      if (!entity.entity_type_ids || !entity.entity_type_ids.length)
        return false;
      return entity.entity_type_ids.indexOf(EntityType.SUPPLIER) > -1;
    });

    return list;
  },
);

export const getEmployees = createSelector(
  [getEntity],
  (entities) => {
    let list = [];

    if (!entities) return list;

    list = entities.filter((entity) => {
      if (!entity.entity_type_ids || !entity.entity_type_ids.length)
        return false;
      return entity.entity_type_ids.indexOf(EntityType.EMPLOYEE) > -1;
    });

    return list;
  },
);

export const getClassifications = createSelector(
  [getClassification],
  (classifications) => {
    let list = [];

    if (!classifications) return list;

    list = classifications.map((classification) => {
      return classification;
    });

    return list;
  },
);

export const getFacets = createSelector(
  [getFacet],
  (facets) => {
    let list = [];

    if (!facets) return list;

    list = facets.map((facet) => {
      return facet;
    });

    return list;
  },
);

export const getBrands = createSelector(
  [getBrand],
  (brands) => {
    let list = [];

    if (!brands) return list;

    list = brands.map((brand) => {
      return brand;
    });

    return list;
  },
);

export const getDeliveryTypes = createSelector(
  [getDeliveryType],
  (deliveryTypes) => {
    let list = [];

    if (!deliveryTypes) return list;

    list = deliveryTypes.map((deliveryType) => {
      return deliveryType;
    });

    return list;
  },
);

export const getCurrencies = createSelector(
  [getCurrency],
  (currencies) => {
    let list = [];

    if (!currencies) return list;

    list = currencies.map((currency) => {
      return currency;
    });

    return list;
  },
);

export const getStoreLocations = createSelector(
  [getLocation],
  (locations) => {
    return locations.filter((location) => {
      return location.location_type._id === LocationType.STORE;
    });
  },
);

export const getPurchaseReasonCodes = createSelector(
  [getReasonCode],
  (reasonCodes) => {
    return reasonCodes.filter((reasonCode) => {
      return reasonCode.purchase;
    });
  },
);

export const getInventoryReasonCodes = createSelector(
  [getReasonCode],
  (reasonCodes) => {
    return reasonCodes.filter((reasonCode) => {
      return reasonCode.inventory;
    });
  },
);

export const getAvailableOnPurchaseDeliveryType = createSelector(
  [getDeliveryType],
  (deliveryTypes) => {
    return deliveryTypes.filter((deliveryType) => {
      return deliveryType.available_on_purchase;
    });
  },
);

export const getPurchaseTransactionStatus = createSelector(
  [getTransactionStatus],
  (transactionStatusList) => {
    return transactionStatusList.filter((transactionStatus) => {
      return transactionStatus.purchase;
    });
  },
);

export const getReceiptTransactionStatus = createSelector(
  [getTransactionStatus],
  (transactionStatusList) => {
    return transactionStatusList.filter((transactionStatus) => {
      return transactionStatus.receipt;
    });
  },
);

export const getReturnTransactionStatus = createSelector(
  [getTransactionStatus],
  (transactionStatusList) => {
    return transactionStatusList.filter((transactionStatus) => {
      return transactionStatus.return;
    });
  },
);

export const getInventoryTransactionStatus = createSelector(
  [getTransactionStatus],
  (transactionStatusList) => {
    return transactionStatusList.filter((transactionStatus) => {
      return transactionStatus.inventory;
    });
  },
);

const getCurrencyId = (state, form) => {
  const selector = formValueSelector(form);
  return selector(state, 'currency_id');
};

export const getCurrencyCode = createSelector(
  [getCurrencyId],
  (currencyId) => {
    const colonLastIndex = currencyId.lastIndexOf(':');
    const currencyCode = currencyId.substring(
      colonLastIndex + 1,
      currencyId.length,
    );
    return currencyCode.toUpperCase();
  },
);

export const getFormCurrencyId = createSelector(
  [getCurrencyId],
  (currencyId) => {
    return currencyId;
  },
);

const getFormSubsidiary = (state, form) => {
  const selector = formValueSelector(form);
  return selector(state, 'subsidiary_id');
};

export const getFormSubsidiaryObject = createSelector(
  [getFormSubsidiary],
  (subsidiary) => subsidiary,
);

export const getPendingInventoryStatus = createSelector(
  [getInventoryStatus],
  (inventoryStatus) => {
    return (inventoryStatus || []).find(
      (status) => status.cid === InventoryStatus.PENDING,
    );
  },
);

export const getOpenTransactionStatus = createSelector(
  [getTransactionStatus],
  (transactionStatus) => {
    return (transactionStatus || []).find(
      (status) => status.cid === TransactionStatus.OPEN,
    );
  },
);

export const getClosedTransactionStatus = createSelector(
  [getTransactionStatus],
  (transactionStatus) => {
    return (transactionStatus || []).find(
      (status) => status.cid === TransactionStatus.CLOSED,
    );
  },
);

export const getClosedAbandonedTransactionStatus = createSelector(
  [getTransactionStatus],
  (transactionStatus) => {
    return (transactionStatus || []).find(
      (status) => status.cid === TransactionStatus.CLOSED_ABANDONED,
    );
  },
);

export const getPendingReceiptTransactionStatus = createSelector(
  [getTransactionStatus],
  (transactionStatus) => {
    return (transactionStatus || []).find(
      (status) => status.cid === TransactionStatus.PENDING_RECEIPT,
    );
  },
);

export const getDropdowns = state => state.dropdown || {};

export const getDropdownList = createSelector(
  [
    getDropdowns,
    (state, name) => name
  ],
  (dropdowns, name) => {
    return (dropdowns[name] || {}).list || []
  }
);

export const getInitialFormValues = createSelector(
  initialFormValuesSelector,
  initialValues => initialValues,
);

export const getAppColorPreference = createSelector(
  [getPreferenceSettings],
  (preferences) => {
    const {
      account: {
        app_color: {
          value: accountAppColor,
        } = {},
      } = {},
      subsidiary: {
        app_color: {
          value: subsidiaryAppColor,
        } = {},
      } = {},
    } = preferences;

    return subsidiaryAppColor || accountAppColor;
  },
);

export const getStateSubsidiary = state => state.subsidiary || {};
export const getPrimarySubsidiary = createSelector(
  [getStateSubsidiary],
  (subsidiary) => subsidiary.primary_subsidiary || {},
);

export const getPrimarySubsidiaryCurrency = createSelector(
  [getPrimarySubsidiary],
  (primarySubsidiary) => primarySubsidiary.currency || {},
);

export const getPrimarySubsidiaryCurrencyId = createSelector(
  [getPrimarySubsidiaryCurrency],
  (primarySubsidiaryCurrency) => primarySubsidiaryCurrency.id,
);

export const getPrimarySubsidiaryTimezone = createSelector(
  [getPrimarySubsidiary],
  (primarySubsidiary) => primarySubsidiary.timezone || null,
);

export const getRoleList = createSelector(
  [getUserRoleAuthority],
  (roleAuthority = []) => {
    const roleListRedundant = roleAuthority
      .reduce((rList, r) => [...rList, ...(r.role_authority_ids || [])], []);
    const roleListSet = [...new Set(roleListRedundant)];
    return roleListSet || [];
  },
);

export const isUserAdmin = createSelector(
  [getUserRoleAuthority],
  (roleAuthority) => (roleAuthority || []).some((r) => r.is_admin),
);

export const getCurrentUserId = createSelector(
  state => state.user,
  user => user.id,
);

export const getCurrentUser = createSelector(
  state => (state || {}).user || {},
  user => user,
);

export const getCurrentTid = createSelector(
  state => state.user,
  user => user.tid,
);

export const getAppHostUrl = createSelector(
  [
    state => get(state, 'app'),
  ],
  state => state.api_host_url,
);

export const getAppAccessToken = createSelector(
  [
    state => get(state, 'app'),
  ],
  state => state.api_access_token,
);

export const getPrimaryLocation = createSelector(
  [
    state => get(state, 'user.employee_primary_location'),
  ],
  location => location,
);

export const getAppClient = createSelector(
  [
    state => get(state, 'app'),
  ],
  app => app.client_api || {},
);
